const FuelCategoryEnum = {
  GASOLINE: "gasoline",
  DIESEL: "diesel",
  KEROSENE: "kerosene",
  LPG: "lpg",
};

export default FuelCategoryEnum;
